import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './config/Redux/store'
import {MsalProvider} from "@azure/msal-react";
import {installAuthInterceptors, msalInstance} from "./config/auth";

// One MSAL instance for the whole app. It used to be created here, but the
// axios interceptors need it too and they run outside the React tree, so it
// lives in config/auth alongside the token refresh that depends on it.
installAuthInterceptors();

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
    <Provider store={store}>
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </React.StrictMode>
    </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()